/* eslint-disable react/button-has-type, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, jsx-a11y/no-autofocus, react/no-unescaped-entities */
/* eslint-disable no-unused-vars, no-useless-return, curly, nonblock-statement-body-position */
/* eslint-disable no-confusing-arrow */
import React, { useState, useEffect } from 'react';
import { SUB_SCREENS } from '../../constants';
import { CloseIcon, EditIcon, F } from '../CommonUI';
import { apiClient } from '../../../../config/axios.config';
import { BASE_EMPLOYEE_URL } from '../../../../store/apiConfig';

const ADDR_INIT = {
  addr1: '',
  addr2: '',
  addr3: '',
  country: '',
  telephone: '',
  mobile: '',
  email: '',
  contact: '',
  emergPerson: '',
  emergNo: '',
};

const ADDRESS_TYPES = {
  local: 'HADD00001',
  permanent: 'HADD00002',
};

const normalizeAddress = payload => {
  if (!payload) return null;
  const row = Array.isArray(payload) ? payload[0] || {} : payload;
  const t = value => (typeof value === 'string' ? value.trim() : value || '');

  return {
    addr1: t(
      row.addr1 || row.addrLn1 || row.AddrLn1 || row.Address1 || row.Add1,
    ),
    addr2: t(
      row.addr2 || row.addrLn2 || row.AddrLn2 || row.Address2 || row.Add2,
    ),
    addr3: t(
      row.addr3 || row.addrLn3 || row.AddrLn3 || row.Address3 || row.Add3,
    ),
    country: t(row.country || row.Country),
    telephone: t(
      row.telephone || row.telephoneNo || row.TelephoneNo || row.Phone,
    ),
    mobile: t(row.mobile || row.mobileNo || row.MobileNo || row.Mobile),
    email: t(row.email || row.Email),
    contact: t(row.contact || row.Contact),
    emergPerson: t(
      row.emergPerson || row.emergencyConPerson || row.EmergencyConPerson,
    ),
    emergNo: t(row.emergNo || row.emergencyConNo || row.EmergencyConNo),
  };
};

const toSafeText = value => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'object') {
    const candidate = value.value ?? value.label ?? '';
    return typeof candidate === 'string' ? candidate.trim() : '';
  }
  return String(value).trim();
};

const validateAddressData = data => {
  const countryValue = toSafeText(data?.country);
  const mandatoryFields = [
    { key: 'addr1', label: 'Address Line 1' },
    { key: 'telephone', label: 'Telephone No.' },
    { key: 'mobile', label: 'Mobile No.' },
    { key: 'emergPerson', label: 'Emergency Contact Person' },
    { key: 'emergNo', label: 'Emergency Contact No.' },
  ];

  const missing = mandatoryFields.find(
    field => !String(data?.[field.key] || '').trim(),
  );
  if (missing) {
    return `Please fill mandatory field: ${missing.label}`;
  }

  if (!countryValue || countryValue.toLowerCase() === 'select country') {
    return 'Please fill mandatory field: Country';
  }

  const numericOnlyFields = [
    { key: 'telephone', label: 'Telephone No.' },
    { key: 'mobile', label: 'Mobile No.' },
    { key: 'emergNo', label: 'Emergency Contact No.' },
  ];
  const invalidNumeric = numericOnlyFields.find(
    field => !/^\d+$/.test(String(data?.[field.key] || '').trim()),
  );
  if (invalidNumeric) {
    return `${invalidNumeric.label} should contain numbers only.`;
  }

  if (!/^[A-Za-z\s]+$/.test(String(data?.emergPerson || '').trim())) {
    return 'Emergency Contact Person should contain alphabets only.';
  }

  return null;
};

function AddressCard({
  title,
  data,
  onChange,
  isEdit,
  setEdit,
  saving,
  onSave,
  onCancel,
  countries,
  readOnly,
}) {
  const handleFieldChange = (name, value) => {
    if (name === 'telephone' || name === 'mobile' || name === 'emergNo') {
      onChange(name, String(value || '').replace(/\D/g, ''));
      return;
    }
    if (name === 'emergPerson') {
      onChange(name, String(value || '').replace(/[^A-Za-z\s]/g, ''));
      return;
    }
    onChange(name, value);
  };

  return (
    <div className="addr-card">
      <div className="addr-card-top">
        <div className="addr-card-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle
              cx="12"
              cy="10"
              r="3"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
          {title}
        </div>
        {!readOnly && (
          <div className="addr-card-btns">
            {isEdit ? (
              <>
                <button
                  className="btn em-btn em-btn-sm em-btn-od"
                  onClick={onCancel}
                  disabled={saving}
                >
                  Cancel
                </button>
                <button
                  className="btn em-btn em-btn-sm em-btn-p"
                  onClick={onSave}
                  disabled={saving}
                >
                  {saving ? 'Saving...' : 'Update'}
                </button>
              </>
            ) : (
              <button
                className="btn em-btn em-btn-sm"
                onClick={() => setEdit(true)}
              >
                <EditIcon size={12} /> Edit
              </button>
            )}
          </div>
        )}
      </div>
      <div className="addr-card-body">
        <F
          label="Address Line 1"
          name="addr1"
          value={data.addr1}
          onChange={handleFieldChange}
          disabled={!isEdit}
          required
        />
        <F
          label="Address Line 2"
          name="addr2"
          value={data.addr2}
          onChange={handleFieldChange}
          disabled={!isEdit}
        />
        <F
          label="Address Line 3"
          name="addr3"
          value={data.addr3}
          onChange={handleFieldChange}
          disabled={!isEdit}
        />
        <F
          label="Country"
          name="country"
          value={data.country}
          onChange={handleFieldChange}
          options={countries || []}
          disabled={!isEdit}
          required
        />
        <F
          label="Telephone No."
          name="telephone"
          value={data.telephone}
          onChange={handleFieldChange}
          disabled={!isEdit}
          required
        />
        <F
          label="Mobile No."
          name="mobile"
          value={data.mobile}
          onChange={handleFieldChange}
          disabled={!isEdit}
          required
        />
        <div className="addr-emerg-h">Emergency Contact</div>
        <F
          label="Emergency Contact Person"
          name="emergPerson"
          value={data.emergPerson}
          onChange={handleFieldChange}
          disabled={!isEdit}
          required
        />
        <F
          label="Emergency Contact No."
          name="emergNo"
          value={data.emergNo}
          onChange={handleFieldChange}
          disabled={!isEdit}
          required
        />
      </div>
    </div>
  );
}

/**
 * Address Sub-Screen
 * ┌──────────────────────────────────────────────────────────────┐
 * │  GET  /api/address/:empCode                                  │
 * │  → { local: { addr1, addr2, addr3, country, telephone,      │
 * │       mobile, emergPerson, emergNo },                        │
 * │     permanent: { ...same fields } }                          │
 * │                                                              │
 * │  PUT  /api/address/:empCode                                  │
 * │  Body: { type: "local"|"permanent", ...address fields }      │
 * │  → { success: true }                                         │
 * └──────────────────────────────────────────────────────────────┘
 */
function AddressScreen({ empName, empCode, onClose, opts, readOnly }) {
  const [local, setLocal] = useState({ ...ADDR_INIT, country: 'UAE' });
  const [perm, setPerm] = useState({ ...ADDR_INIT });
  const [editLocal, setEditLocal] = useState(false);
  const [editPerm, setEditPerm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [savingLocal, setSavingLocal] = useState(false);
  const [savingPerm, setSavingPerm] = useState(false);
  const [error, setError] = useState(null);
  const [origLocal, setOrigLocal] = useState(null);
  const [origPerm, setOrigPerm] = useState(null);

  useEffect(() => {
    if (!empCode) return;
    const loadAddress = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await apiClient.create(
          `${BASE_EMPLOYEE_URL}/get-address`,
          {
            employeeId: empCode,
          },
        );
        const rows = Array.isArray(data?.result)
          ? data.result
          : Array.isArray(data)
            ? data
            : [];

        const localRaw = rows.find(
          row =>
            String(row?.AddTyp || row?.addTyp || '').trim() ===
            ADDRESS_TYPES.local,
        );
        const permRaw = rows.find(
          row =>
            String(row?.AddTyp || row?.addTyp || '').trim() ===
            ADDRESS_TYPES.permanent,
        );

        const localData = normalizeAddress(localRaw);
        const permData = normalizeAddress(permRaw);

        if (localData) {
          setLocal(localData);
          setOrigLocal(localData);
        }
        if (permData) {
          setPerm(permData);
          setOrigPerm(permData);
        }
      } catch (err) {
        console.error('Load address:', err);
        setError('Failed to load address data.');
      } finally {
        setLoading(false);
      }
    };

    loadAddress();
  }, [empCode]);

  useEffect(() => {
    if (readOnly) {
      setEditLocal(false);
      setEditPerm(false);
    }
  }, [readOnly]);

  const saveAddress = async (type, data, setSaving, setEditMode) => {
    const validationError = validateAddressData(data);
    if (validationError) {
      setError(validationError);
      return;
    }

    const countryValue = toSafeText(data?.country);
    const addressType = ADDRESS_TYPES[type] || ADDRESS_TYPES.local;
    const payload = {
      employeeId: empCode,
      addTyp: addressType,
      add1: data.addr1,
      add2: data.addr2,
      add3: data.addr3,
      country: countryValue,
      phone: data.telephone,
      mobile: data.mobile,
      emergencyConPerson: data.emergPerson,
      emergencyConNo: data.emergNo,
    };

    setSaving(true);
    setError(null);

    try {
      await apiClient.create(`${BASE_EMPLOYEE_URL}/create-address`, payload);

      setEditMode(false);
      if (type === 'local') setOrigLocal({ ...data });
      else setOrigPerm({ ...data });
    } catch (err) {
      console.error('Save address:', err);
      setError('Failed to save address.');
    } finally {
      setSaving(false);
    }
  };

  const cancelLocal = () => {
    setEditLocal(false);
    if (origLocal) setLocal(origLocal);
  };
  const cancelPerm = () => {
    setEditPerm(false);
    if (origPerm) setPerm(origPerm);
  };

  return (
    <div className="ov">
      <div
        className="sub-modal sub-modal-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="sub-modal-top comp-modal-top">
          <div className="sub-modal-title">
            <div className="sub-modal-title-row sub-modal-title-row--stacked comp-modal-title-row">
              <span className="sub-modal-icon sub-modal-icon--lg comp-modal-icon-shell">
                <span className="comp-modal-icon-inner">
                  {SUB_SCREENS[4].icon}
                </span>
              </span>
              <div className="sub-modal-title-block">
                <h2>Address</h2>
                {empCode && (
                  <span className="sub-modal-emp sub-modal-emp--stacked">
                    {[empName, empCode].filter(Boolean).join(' \u00b7 ')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <button className="mdl-x" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="sub-modal-body">
          {error && (
            <div
              style={{
                padding: '12px 20px',
                background: 'var(--red-l)',
                color: 'var(--red)',
                fontSize: 13,
                fontWeight: 500,
                marginBottom: 12,
                borderRadius: 'var(--r)',
              }}
            >
              {error}
            </div>
          )}
          {loading ? (
            <div className="sub-empty">
              <span>Loading address data...</span>
            </div>
          ) : (
            <div className="addr-grid">
              <AddressCard
                title="Local Address"
                data={local}
                onChange={(n, v) => setLocal(p => ({ ...p, [n]: v }))}
                isEdit={editLocal}
                setEdit={setEditLocal}
                saving={savingLocal}
                onSave={() =>
                  saveAddress('local', local, setSavingLocal, setEditLocal)
                }
                onCancel={cancelLocal}
                countries={opts?.country || []}
                readOnly={readOnly}
              />
              <AddressCard
                title="Permanent Address (Home Country)"
                data={perm}
                onChange={(n, v) => setPerm(p => ({ ...p, [n]: v }))}
                isEdit={editPerm}
                setEdit={setEditPerm}
                saving={savingPerm}
                onSave={() =>
                  saveAddress('permanent', perm, setSavingPerm, setEditPerm)
                }
                onCancel={cancelPerm}
                countries={opts?.country || []}
                readOnly={readOnly}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddressScreen;
